var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["players-list", _vm.clsName || ""] }, [
    _vm.heading
      ? _c("div", { staticClass: "main-header" }, [
          _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.heading))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "player-item sub-header" }, [
      _c("div", { staticClass: "item item-1" }, [
        _vm._v(_vm._s(_vm.translations.name)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item item-2 grade-section" }, [
        _c("div", { staticClass: "grade-wrap" }, [
          _c("span", { staticClass: "title-1" }, [
            _vm._v(_vm._s(_vm.translations.fantasyGully)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "title-2" }, [
            _vm._v(_vm._s(_vm.translations.rating)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            class: [
              "info-wrap",
              _vm.rating_tool_tip.recommended_11 ? "active" : "",
            ],
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.closeToolTipExcept(
                  "rating_tool_tip",
                  "recommended_11"
                )
              },
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.rating_tool_tip.recommended_11,
                    expression: "rating_tool_tip.recommended_11",
                  },
                ],
                staticClass: "info-modal",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.closeToolTipExcept.apply(null, arguments)
                  },
                },
              },
              [_c("p", [_vm._v(_vm._s(_vm.translations.modal_txt_rating))])]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item item-3 x-factor" }, [
        _c("img", {
          staticClass: "x-factor-img",
          attrs: {
            src: "/static-assets/images/cssimages/x-factor-web.png",
            alt: "",
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            class: [
              "info-wrap",
              _vm.xf_tool_tip.recommended_11 ? "active" : "",
            ],
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.closeToolTipExcept("xf_tool_tip", "recommended_11")
              },
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.xf_tool_tip.recommended_11,
                    expression: "xf_tool_tip.recommended_11",
                  },
                ],
                staticClass: "info-modal",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.closeToolTipExcept.apply(null, arguments)
                  },
                },
              },
              [_c("p", [_vm._v(_vm._s(_vm.translations.modal_txt_xf))])]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item item-4 more-info" }, [
        _c("span", { staticClass: "icon-lock" }),
        _vm._v(" "),
        _c(
          "span",
          {
            class: [
              "info-wrap",
              _vm.lock_tool_tip.recommended_11 ? "active" : "",
            ],
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.closeToolTipExcept("lock_tool_tip", "recommended_11")
              },
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.lock_tool_tip.recommended_11,
                    expression: "lock_tool_tip.recommended_11",
                  },
                ],
                staticClass: "info-modal",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.closeToolTipExcept.apply(null, arguments)
                  },
                },
              },
              [_c("p", [_vm._v(_vm._s(_vm.translations.modal_txt_lock))])]
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    !_vm.teamList.length
      ? _c(
          "div",
          { staticClass: "player-details" },
          _vm._l(11, function (i) {
            return _c("div", { key: i, staticClass: "player-item isempty" })
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "player-details" },
          _vm._l(_vm.teamList, function (player) {
            return _c("div", { key: player.pid, staticClass: "player-item" }, [
              _c("div", { staticClass: "item item-1 item1-wrap" }, [
                _c("div", { staticClass: "skill-wrap" }, [
                  _c("span", { staticClass: "player-skill-txt" }, [
                    _vm._v(_vm._s(_vm.printSkillName(player.sid, "sname"))),
                  ]),
                  _vm._v(" "),
                  player.in_form
                    ? _c("span", { staticClass: "trending" })
                    : _vm._e(),
                  _vm._v(" "),
                  player.in_form
                    ? _c(
                        "span",
                        {
                          class: [
                            "player-skill info-wrap trending",
                            { active: _vm.trending_tool_tip[player.pid] },
                          ],
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.addToTrending(player.pid)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "info-modal" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.translations.modal_txt_trending)
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "player-name-wrap no-select",
                    on: {
                      click: function ($event) {
                        return _vm.onOpenPlayerPopup(player)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(player.pn))]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(player.tsn) +
                          " | " +
                          _vm._s(_vm.translations.price) +
                          " -\n            "
                      ),
                      _c("span", { staticClass: "price" }, [
                        _vm._v(_vm._s(player.pr)),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                player.is_c
                  ? _c("span", { staticClass: "main-player captain" })
                  : player.is_vc
                  ? _c("span", { staticClass: "main-player vice-captain" })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item item-2" }, [
                _vm._v(_vm._s(_vm.ratingDisplayVal(player.fr))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item item-3 ratings" },
                [_c("rating-meter", { attrs: { meterVal: player.xfp } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item item-4 reactions in-out-section" },
                [
                  _c(
                    "span",
                    {
                      class: [
                        "react",
                        "btn-in",
                        _vm.locked_players.includes(+player.pid)
                          ? "active"
                          : null,
                        _vm.current_match.status !== 1 ? "btn-disabled" : null,
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.lockPlayer("in", +player.pid)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.translations.in))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: [
                        "react",
                        "btn-out",
                        _vm.out_players.includes(+player.pid) ? "active" : null,
                        _vm.current_match.status !== 1 ? "btn-disabled" : null,
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.lockPlayer("out", +player.pid)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.translations.out))]
                  ),
                ]
              ),
            ])
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }